import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useReducer } from 'react';
import { NetworkCoverageWizard } from './NetworkCoverageWizard';
import { NetworkCoverageContext, NetworkCoverageReducer, defaultNetworkCoverageState } from './NetworkCoverageContext';
const debug = process.env.REACT_APP_DEBUG && false;
const NetworkCoverageViewBase = (props) => {
    debug && console.log(`NetworkCoverageViewBase rerendering, `);
    const [state, dispatch] = useReducer(NetworkCoverageReducer, defaultNetworkCoverageState);
    return (_jsx(_Fragment, { children: _jsx(NetworkCoverageContext.Provider, { value: { state, dispatch }, children: _jsx(NetworkCoverageWizard, { ...props }) }) }));
};
export { NetworkCoverageViewBase as NetworkCoverageView };
